module.exports = __webpack_public_path__ + "assets/img/优鱼优养.71bee582.png";